module.exports = __webpack_public_path__ + "static/media/w-logo.6e67c2bb.png";